export default __webpack_public_path__ + "static/media/Icon1.cfb2370e.svg";